// Central palette + design tokens. Balatro-leaning, but warmer and friendlier
// for a kid-facing math game: deep teal felt, cream cards, candy scoring colors.

export const palette = {
  // felt table
  bgTop: 0x16414f,
  bgBottom: 0x0a151d,
  // cards
  cardFace: 0xf6edd6,
  cardEdge: 0x2b3d47,
  ink: 0x213139,
  glow: 0x57e6c3,
  // scoring (chips × mult → score)
  chip: 0x35c7ff, // blue chips
  mult: 0xff5d6c, // red mult
  gold: 0xffd24a, // score gold
  good: 0x5ce08a, // success green
  bad: 0xff7a6b, // gentle "try again" red
  // slot / structure
  slot: 0x0a151c,
  slotEdge: 0x57e6c3,
  text: 0xf6edd6,
  textDim: 0x83a6a8,
  // ambient blobs
  blob1: 0x1f7d77,
  blob2: 0x2a4f86,
} as const;

export const FONT = "Fredoka";
